export const isProduction =
  import.meta.env.VITE_PUBLIC_ENVIRONMENT === "production";
export const isTest = import.meta.env.VITE_PUBLIC_ENVIRONMENT === "test";
export const MIN_CHILD_AGE = 2;
export const MIN_ADULT_AGE = 12;
export const MAX_CHILDREN_PER_ROOM = 8;
export const MAX_VISITORS_PER_ROOM = 9;
export const MAX_TRAVELLERS = 9;
export const HOTEL_CLASSES = [0, 1, 2, 3, 4, 5];
export const BOARD_BASIS_OPTIONS = ["HB", "FB", "AI", "RO", "SC", "BB", "RD"];
